import React, { useState, useEffect } from 'react';
import {
  IconButton
} from '@material-ui/core';
import { Close, Menu } from '@material-ui/icons';
import AsideContent from '../../molecules/AsideContent';
import { PedalsProvider } from '../Pedalboard/context';
import { Aside, Row, Container, Header, UtilArea } from './styles';
import logo from './logo.png';

type Props = {
  dashboard?: boolean;
}

const Layout: React.FC<Props> = ({ children, dashboard }) => {
  const [openAside, setOpenAside] = useState(true);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);

  useEffect(() => {
    window.onresize = () => {
      setScreenHeight(window.innerHeight);
    };
  }, []);

  return (
    <Container className={dashboard ? 'dashboard' : ''}>
      <Header>
        <IconButton onClick={() => setOpenAside(!openAside)} className="toggle-aside">
          {openAside ? <Close /> : <Menu />}
        </IconButton>
        <img className="logo" src={logo} alt="" />
      </Header>
      <Row>
        {
          !dashboard && (
            <Aside screenHeight={screenHeight} className={openAside ? 'opened' : ''}>
              <AsideContent />
            </Aside>
          )
        }
        <UtilArea screenHeight={screenHeight}>
          <div className="util-wrapper">
            {children}
          </div>
        </UtilArea>
      </Row>
    </Container>
  );
}

export default Layout;